"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'share.conversation.loading': '正在加载对话...',
    'share.conversation.noIdProvided': '未提供对话ID',
    'share.conversation.failedToLoad': '无法加载对话',
    'share.conversation.untitled': '无标题对话',
    'share.conversation.linkCopied': '链接已复制到剪贴板',
    'share.conversation.linkCopyFailed': '无法复制链接',
    'share.conversation.copyLink': '复制链接',
    'share.conversation.goToChat': '前往聊天',
    'share.conversation.you': '您',
    'share.conversation.assistant': '助手',
    'share.conversation.reasoning': '推理',
    'share.conversation.thoughts': '思考',
    'share.conversation.sources': '来源',
    'share.conversation.toolsUsed': '使用的工具',
    'share.conversation.noMessages': '未找到消息',
    'share.conversation.noMessagesDescription': '此对话似乎为空或无法加载消息。',
    'share.conversation.footerNote': '这是一个共享对话。您可以开始自己的聊天与AI互动。',
    'share.conversation.startNewChat': '开始新聊天',
    'share.conversation.unknownModel': '未知模型',
};
